'use strict';

/**
 * updates the totals summary
 * @param {Array} totals - the totals data
 */
function updateTotals(totals) {
    $('.shipping-total-cost').text(totals.totalShippingCost);

    // Update tax total
    var $taxTotal = $('.tax-total');
    $taxTotal.text(totals.totalTax);

    $('.sub-total').text(totals.subTotal);

    // Update grand total
    var $grandTotal = $('.grand-total-sum');
    $grandTotal.text(totals.grandTotal);

    $('.coupons-and-promos').empty().append(totals.discountsHtml);
    if (totals.giftCardTotal && totals.giftCardTotal.value > 0) {
        $('.giftcertificate-item .sub-total').empty().append(totals.giftCardTotal.formatted);
        $('.order-totals .giftcertificate-item').removeClass('d-none');
    } else {
        $('.giftcertificate-item .sub-total').empty();
        $('.order-totals .giftcertificate-item').addClass('d-none');
    }
    if (totals.productLevelDiscountTotal.value > 0) {
        $('.product-discount').removeClass('d-none');
        $('.product-discount-total').empty()
            .append('- ' + totals.productLevelDiscountTotal.formatted);
    } else {
        $('.product-discount').addClass('d-none');
    }
    if (totals.bounsProductDiscountTotal.value > 0) {
        $('.bouns-product-discount').removeClass('d-none');
        $('.bouns-product-discount-total').empty()
            .append('- ' + totals.bounsProductDiscountTotal.formatted);
    } else {
        $('.bouns-product-discount').addClass('d-none');
    }
    if (totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').text('- ' + totals.orderLevelDiscountTotal.formatted);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').text('- ' +
            totals.shippingLevelDiscountTotal.formatted);
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }
    if (totals.shippingLevelDiscountTotal.value > 0 &&
        totals.shippingLevelDiscountTotal.formatted !== totals.totalShippingCost) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').empty().append('- ' +
            totals.shippingLevelDiscountTotal.formatted);
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }
    if (totals.shippingLevelDiscountTotal.value > 0 &&
        totals.shippingLevelDiscountTotal.formatted === totals.totalShippingCost) {
        $('.free-shipping-discount').removeClass('d-none');
        $('.shipping-total-cost').each(function () {
            var cost = $(this).find('s').text().trim() || $(this).text().trim();
            $(this).addClass('strike-through')
                .html('<span class="sr-only">Old shipping cost: </span><s>' + cost + '</s>');
        });
    } else {
        $('.free-shipping-discount').addClass('d-none');
        $('.shipping-total-cost').each(function () {
            var cost = $(this).find('s').text().trim() || $(this).text().trim();
            $(this).removeClass('strike-through').text(cost);
        });
    }
    if (totals.giftWrapPrice !== '-') {
        $('.gift-wrap-item').removeClass('d-none');
        var $giftWrapTotal = $('.gift-wrap-total');
        $giftWrapTotal.empty().append(totals.giftWrapPrice);
    } else {
        $('.gift-wrap-item').addClass('d-none');
        $('.gift-wrap-total').empty();
    }

    var grandTotalValue = totals && totals.grandTotal && /[$£€]/.test(totals.grandTotal)
    ? totals.grandTotal.replace(/[$£€]/g, '')
    : totals.grandTotal;
    if (totals && totals.totalValue <= 0) {
        $('.payment-method-title').addClass('d-none');
        $('.gift-card-section').addClass('d-none');
        $('.payment-method-section').addClass('d-none');
        $('.use-shipping-for-billing-container').addClass('d-none');
    } else if (!isNaN(grandTotalValue) && grandTotalValue <= 0) {
        $('.payment-method-title').addClass('d-none');
        $('.payment-method-section').addClass('d-none');
    } else {
        $('.payment-method-title').removeClass('d-none');
        $('.gift-card-section').removeClass('d-none');
        $('.payment-method-section').removeClass('d-none');
        $('.use-shipping-for-billing-container').removeClass('d-none');
    }
}

/**
 * updates the order product shipping summary groups for an order model
 * @param {Object} shipment - the order shipping models' shipping groups
 */
function updateShippingOptionsProductGroupsInformation(shipment) {
    $('.shipment-groups-wrapper').html(shipment.shipmentGroupsHTML);
}

function handleShippingNoticeSplitShipmentsInformation(hide) {
    $('.js_shipping-notice-split-shipments').toggleClass('d-none', hide);
}

/**
 * updates the order product shipping summary groups for an order model
 * @param {Object} shipmentGroups - the order shipping models' shipping groups
 * @returns {Object} - new created Order Product Summary div
 */
function updateOrderProductSummaryGroupsInformation(shipmentGroups) {
    var index = 1;
    var $shippingGroupContainer = $('<div />');
    // eslint-disable-next-line no-undef
    var itemMap = new Map();
    for (var i = 0; i < shipmentGroups.length; i++) {
        var group = shipmentGroups[i];
        var $shippingGroupWrapper = $('<div class="mb-3 shipment-group" />');
        var multipleShipments = shipmentGroups.length > 1 ? '' : ' d-none';
        var extraPadding = i !== 0 ? ' pt-3' : '';
        var $shipmentHeading = $('<div class="shipment-group-name ' + extraPadding + multipleShipments + '" tabindex="0"/>');
        $shipmentHeading.append($('.product-summary-block').data('shipment-heading') + index);
        $shippingGroupWrapper.append($shipmentHeading);
        $shippingGroupContainer.append($shippingGroupWrapper);
        index++;
        var $shippingClassContainer = $('<div class="shipment-group-date" tabindex="0"/>');
        $shippingClassContainer.append(group.formattedDate);
        $shippingGroupWrapper.append($shippingClassContainer);
        var $productLineItems = $('<div />');
        // eslint-disable-next-line no-loop-func
        group.items.forEach(function (lineItem) {
            var pli = $('.order-summary-wrapper')
                .first()
                .find('.product-summary-block')
                .first()
                .find('[data-product-line-item=' + lineItem.UUID + ']');
            var gwPli;
            if (group.shipmentType === 'gwInStock') {
                gwPli = $('.order-summary-wrapper').first().find('.gwInStock-items[data-product-line-item=' + lineItem.UUID + ']').first();
                if (gwPli.length === 0) {
                    gwPli = pli.clone();
                    if (pli.length === 0) {
                        gwPli = itemMap.get(lineItem.UUID);
                    }
                    gwPli.removeClass('inStock-items');
                    gwPli.addClass('gwInStock-items');
                }
                if (lineItem.giftWrapQuantity === lineItem.quantity && !pli.hasClass('gwInStock-items')) {
                    pli.addClass('d-none');
                } else {
                    pli.removeClass('d-none');
                }
                gwPli.removeClass('d-none');
                gwPli.find('.gift-box-message span').html(lineItem.giftBoxMessage);
                gwPli.find('.qty-card-quantity-count').html(lineItem.giftWrapQuantity);
                $productLineItems.append(gwPli);
            } else if (group.shipmentType === 'gwEmboroidered') {
                gwPli = $('.order-summary-wrapper').first().find('.gwEmboroidered-items[data-product-line-item=' + lineItem.UUID + ']').first();
                if (gwPli.length === 0) {
                    gwPli = pli.clone();
                    if (pli.length === 0) {
                        gwPli = itemMap.get(lineItem.UUID);
                    }
                    gwPli.removeClass('emboroidered-items');
                    gwPli.addClass('gwEmboroidered-items');
                }
                if (lineItem.giftWrapQuantity === lineItem.quantity && !pli.hasClass('gwEmboroidered-items')) {
                    pli.addClass('d-none');
                } else {
                    pli.removeClass('d-none');
                }
                gwPli.removeClass('d-none');
                gwPli.find('.gift-box-message span').html(lineItem.giftBoxMessage);
                gwPli.find('.qty-card-quantity-count').html(lineItem.giftWrapQuantity);
                $productLineItems.append(gwPli);
            } else if (group.shipmentType === 'emboroidered') {
                if (lineItem.giftWrapQuantity > 0 && lineItem.giftWrapQuantity !== lineItem.quantity) {
                    gwPli = $('.order-summary-wrapper').first().find('.gwEmboroidered-items[data-product-line-item=' + lineItem.UUID + ']').first();
                    if (gwPli.length === 0) {
                        gwPli = pli.clone();
                        gwPli.removeClass('emboroidered-items');
                        gwPli.addClass('gwEmboroidered-items');
                        itemMap.set(lineItem.UUID, gwPli);
                    } else {
                        itemMap.set(lineItem.UUID, gwPli);
                    }
                }
                if (lineItem.giftWrapQuantity === 0 && $('.gwEmboroidered-items[data-product-line-item=' + lineItem.UUID + ']').length > 0) {
                    gwPli = $('.order-summary-wrapper').first().find('.gwEmboroidered-items[data-product-line-item=' + lineItem.UUID + ']').first();
                    if (pli.length === 1 && pli.hasClass('gwEmboroidered-items')) {
                        pli.addClass('emboroidered-items');
                        pli.removeClass('gwEmboroidered-items');
                    } else {
                        $('.gwEmboroidered-items[data-product-line-item=' + lineItem.UUID + ']').addClass('d-none');
                    }
                }
                if (gwPli && pli.length === gwPli.length) {
                    pli = gwPli.clone();
                    pli.addClass('emboroidered-items');
                    pli.removeClass('gwEmboroidered-items');
                    pli.removeClass('d-none');
                }
                pli.find('.gift-box-message span').html(lineItem.giftBoxMessage);
                pli.find('.qty-card-quantity-count').html(lineItem.quantity - lineItem.giftWrapQuantity);
                $productLineItems.append(pli);
            } else if (group.shipmentType === 'gwStandard') {
                gwPli = $('.order-summary-wrapper').first().find('.gwStandard-items[data-product-line-item=' + lineItem.UUID + ']').first();
                if (gwPli.length === 0) {
                    gwPli = pli.clone();
                    if (pli.length === 0) {
                        gwPli = itemMap.get(lineItem.UUID);
                    }
                    gwPli.removeClass('standard-items');
                    gwPli.addClass('gwStandard-items');
                }
                if (lineItem.giftWrapQuantity === lineItem.quantity && !pli.hasClass('gwStandard-items')) {
                    pli.addClass('d-none');
                } else {
                    pli.removeClass('d-none');
                }
                gwPli.removeClass('d-none');
                gwPli.find('.gift-box-message span').html(lineItem.giftBoxMessage);
                gwPli.find('.qty-card-quantity-count').html(lineItem.giftWrapQuantity);
                $productLineItems.append(gwPli);
            } else if (group.shipmentType === 'standard') {
                if (lineItem.giftWrapQuantity > 0 && lineItem.giftWrapQuantity !== lineItem.quantity) {
                    gwPli = $('.order-summary-wrapper').first().find('.gwStandard-items[data-product-line-item=' + lineItem.UUID + ']').first();
                    if (gwPli.length === 0) {
                        gwPli = pli.clone();
                        gwPli.removeClass('standard-items');
                        gwPli.addClass('gwStandard-items');
                        itemMap.set(lineItem.UUID, gwPli);
                    } else {
                        itemMap.set(lineItem.UUID, gwPli);
                    }
                }
                if (lineItem.giftWrapQuantity === 0 && $('.gwStandard-items[data-product-line-item=' + lineItem.UUID + ']').length > 0) {
                    gwPli = $('.order-summary-wrapper').first().find('.gwStandard-items[data-product-line-item=' + lineItem.UUID + ']').first();
                    if (pli.length === 1 && pli.hasClass('gwStandard-items')) {
                        pli.addClass('standard-items');
                        pli.removeClass('gwStandard-items');
                    } else {
                        $('.gwStandard-items[data-product-line-item=' + lineItem.UUID + ']').addClass('d-none');
                    }
                }
                if (gwPli && pli.length === gwPli.length) {
                    pli = gwPli.clone();
                    pli.addClass('standard-items');
                    pli.removeClass('gwStandard-items');
                    pli.removeClass('d-none');
                }
                pli.find('.gift-box-message span').html(lineItem.giftBoxMessage);
                pli.find('.qty-card-quantity-count').html(lineItem.quantity - lineItem.giftWrapQuantity);
                $productLineItems.append(pli);
            } else if (group.shipmentType === 'gwDurham') {
                gwPli = $('.order-summary-wrapper').first().find('.gwDurham-items[data-product-line-item=' + lineItem.UUID + ']').first();
                if (lineItem.giftWrapQuantity > 0) {
                    if (gwPli.length === 0) {
                        gwPli = pli.clone();
                        if (pli.length === 0) {
                            gwPli = itemMap.get(lineItem.UUID);
                        }
                        gwPli.removeClass('durham-items');
                        gwPli.addClass('gwDurham-items');
                    }
                    if (lineItem.giftWrapQuantity === lineItem.quantity && !pli.hasClass('gwDurham-items')) {
                        pli.addClass('d-none');
                    } else {
                        pli.removeClass('d-none');
                    }
                    gwPli.removeClass('d-none');
                }
                gwPli.find('.gift-box-message span').html(lineItem.giftBoxMessage);
                gwPli.find('.qty-card-quantity-count').html(lineItem.giftWrapQuantity);
                $productLineItems.append(gwPli);
            } else if (group.shipmentType === 'durham') {
                if (lineItem.giftWrapQuantity > 0 && lineItem.giftWrapQuantity !== lineItem.quantity) {
                    gwPli = $('.order-summary-wrapper').first().find('.gwDurham-items[data-product-line-item=' + lineItem.UUID + ']').first();
                    if (gwPli.length === 0) {
                        gwPli = pli.clone();
                        gwPli.removeClass('durham-items');
                        gwPli.addClass('gwDurham-items');
                        itemMap.set(lineItem.UUID, gwPli);
                    } else {
                        itemMap.set(lineItem.UUID, gwPli);
                    }
                }
                if (lineItem.giftWrapQuantity === 0 && $('.gwDurham-items[data-product-line-item=' + lineItem.UUID + ']').length > 0) {
                    gwPli = $('.order-summary-wrapper').first().find('.gwDurham-items[data-product-line-item=' + lineItem.UUID + ']').first();
                    if (pli.length === 1 && pli.hasClass('gwDurham-items')) {
                        pli.addClass('durham-items');
                        pli.removeClass('gwDurham-items');
                    } else {
                        $('.gwDurham-items[data-product-line-item=' + lineItem.UUID + ']').addClass('d-none');
                    }
                }
                if (gwPli && pli.length === gwPli.length) {
                    pli = gwPli.clone();
                    pli.addClass('durham-items');
                    pli.removeClass('gwDurham-items');
                    pli.removeClass('d-none');
                }

                pli.find('.gift-box-message span').html(lineItem.giftBoxMessage);
                pli.find('.qty-card-quantity-count').html(lineItem.quantity - lineItem.giftWrapQuantity);
                $productLineItems.append(pli);
            } else {
                if (lineItem.giftWrapQuantity > 0 && lineItem.giftWrapQuantity !== lineItem.quantity) {
                    gwPli = $('.order-summary-wrapper').first().find('.gwInStock-items[data-product-line-item=' + lineItem.UUID + ']').first();
                    if (gwPli.length === 0) {
                        gwPli = pli.clone();
                        gwPli.removeClass('inStock-items');
                        gwPli.addClass('gwInStock-items');
                        itemMap.set(lineItem.UUID, gwPli);
                    } else {
                        itemMap.set(lineItem.UUID, gwPli);
                    }
                }
                if (lineItem.giftWrapQuantity === 0 && $('.gwInStock-items[data-product-line-item=' + lineItem.UUID + ']').length > 0) {
                    gwPli = $('.order-summary-wrapper').first().find('.gwInStock-items[data-product-line-item=' + lineItem.UUID + ']').first();
                    if (pli.length === 1 && pli.hasClass('gwInStock-items')) {
                        pli.addClass('inStock-items');
                        pli.removeClass('gwInStock-items');
                    } else {
                        $('.gwInStock-items[data-product-line-item=' + lineItem.UUID + ']').addClass('d-none');
                    }
                }
                if (gwPli && pli.length === gwPli.length) {
                    pli = gwPli.clone();
                    pli.addClass('inStock-items');
                    pli.removeClass('gwInStock-items');
                    pli.removeClass('d-none');
                }
                pli.find('.gift-box-message span').html(lineItem.giftBoxMessage);
                pli.find('.qty-card-quantity-count').html(lineItem.quantity - lineItem.giftWrapQuantity);
                $productLineItems.append(pli);
            }
        });
        $shippingGroupContainer.append($productLineItems);
    }
    return $shippingGroupContainer;
}

/**
 * updates the order product shipping summary for an order model
 * @param {Object} order - the order model
 */
function updateOrderProductSummaryInformation(order) {
    var $productSummary = $('<div />');
    order.shipping.forEach(function (shipping) {
        if (order && !order.renderedOrderProductSummary) {
            if (shipping.shipmentGroups && shipping.shipmentGroups.length > 0) {
                $productSummary.append(updateOrderProductSummaryGroupsInformation(shipping.shipmentGroups));
                updateShippingOptionsProductGroupsInformation(shipping);
            } else {
                shipping.productLineItems.items.forEach(function (lineItem) {
                    var pli = $('.order-summary-wrapper').first().find('[data-product-line-item=' + lineItem.UUID + ']').first();
                    $productSummary.append(pli);
                });
            }
        } else if (shipping.shipmentGroups && shipping.shipmentGroups.length > 0) {
            updateShippingOptionsProductGroupsInformation(shipping);
        }

        // The order model already decides this per site (single shipment sites never show it).
        handleShippingNoticeSplitShipmentsInformation(!order.showSplitShipmentMessaging);

        var address = shipping.shippingAddress || {};
        var selectedMethod = shipping.selectedShippingMethod;

        var nameLine = address.firstName ? address.firstName + ' ' : '';
        if (address.lastName) nameLine += address.lastName;

        var address1Line = address.address1;
        var address2Line = address.address2;

        var phoneLine = address.phone;

        var shippingCost = selectedMethod ? selectedMethod.shippingCost : '';
        var methodNameLine = selectedMethod ? selectedMethod.displayName : '';
        var methodArrivalTime = selectedMethod && selectedMethod.estimatedArrivalTime
            ? '( ' + selectedMethod.estimatedArrivalTime + ' )'
            : '';

        var tmpl = $('#pli-shipping-summary-template').clone();

        if (shipping.productLineItems.items && shipping.productLineItems.items.length > 1) {
            $('h5 > span').text(' - ' + shipping.productLineItems.items.length + ' '
                + order.resources.items);
        } else {
            $('h5 > span').text('');
        }

        var stateRequiredAttr = $('#shippingState').attr('required');
        var isRequired = stateRequiredAttr !== undefined && stateRequiredAttr !== false;
        var stateExists = (shipping.shippingAddress && shipping.shippingAddress.stateCode)
            ? shipping.shippingAddress.stateCode
            : false;
        var stateBoolean = false;
        if ((isRequired && stateExists) || (!isRequired)) {
            stateBoolean = true;
        }

        if (shipping.shippingAddress
            && shipping.shippingAddress.firstName
            && shipping.shippingAddress.address1
            && shipping.shippingAddress.city
            && stateBoolean
            && shipping.shippingAddress.countryCode
            && (shipping.shippingAddress.phone || shipping.productLineItems.items[0].fromStoreId)) {
            $('.ship-to-name', tmpl).text(nameLine);
            $('.ship-to-address1', tmpl).text(address1Line);
            $('.ship-to-address2', tmpl).text(address2Line);
            $('.ship-to-city', tmpl).text(address.city);
            if (address.stateCode) {
                $('.ship-to-st', tmpl).text(address.stateCode);
            }
            $('.ship-to-zip', tmpl).text(address.postalCode);
            $('.ship-to-phone', tmpl).text(phoneLine);

            if (!address2Line) {
                $('.ship-to-address2', tmpl).hide();
            }

            if (!phoneLine) {
                $('.ship-to-phone', tmpl).hide();
            }
        }

        if (shipping.isGift) {
            $('.gift-message-summary', tmpl).text(shipping.giftMessage);
        } else {
            $('.gift-summary', tmpl).addClass('d-none');
        }

        // checking h5 title shipping to or pickup
        var $shippingAddressLabel = $('.shipping-header-text', tmpl);
        $('body').trigger('shipping:updateAddressLabelText',
            { selectedShippingMethod: selectedMethod, resources: order.resources, shippingAddressLabel: $shippingAddressLabel });

        if (shipping.selectedShippingMethod) {
            $('.display-name', tmpl).text(methodNameLine);
            $('.arrival-time', tmpl).text(methodArrivalTime);
            $('.price', tmpl).text(shippingCost);
        }
    });

    if (order && !order.renderedOrderProductSummary) {
        $('.product-summary-block').html($productSummary.html());
    }

    // Also update the line item prices, as they might have been altered
    $('.grand-total-price').text(order.totals.subTotal);
    order.items.items.forEach(function (item) {
        if (item.priceTotal && item.priceTotal.renderedPrice) {
            $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
        }
        if (item.isFinalSale) {
            $('.product-details-summary [data-product-line-item="' + item.UUID + '"]').removeClass('d-none');
        } else {
            $('.product-details-summary [data-product-line-item="' + item.UUID + '"]').addClass('d-none');
        }
    });

    if (order && order.renderedOrderProductSummary) {
        $('.product-summary-block').closest('.order-product-summary').replaceWith(order.renderedOrderProductSummary);
    }
}

module.exports = {
    updateTotals: updateTotals,
    updateOrderProductSummaryInformation: updateOrderProductSummaryInformation
};
